module.exports = __webpack_public_path__ + "static/media/userImg.d6a54172.png";